// React
import { useState, useEffect } from 'react'

import AlgoliaSearch from './AlgoliaSearch'

export default function ShopifyVariantSelect({
    onSelect,
    placeholder = 'Rechercher une variante Shopify...',
    label,
}) {
    return (
        <>
            <AlgoliaSearch
                algolia_index="engine_shopify_product_variants"
                placeholder={placeholder}
                onSelect={onSelect}
                label={label}
            />
        </>
    )
}
